import React from "react";

const TabNavItem_admin = ({ id, title, activeTab, setActiveTab }) => {
  const handleClick = () => {
    setActiveTab(id);
  };

  return (
    <li
      onClick={handleClick}
      className={activeTab === id ? "active-admin" : ""}
    >
      {title}
    </li>
  );
};
export default TabNavItem_admin;
